import { useEffect } from 'react'
import { Container, Content, Footer } from 'rsuite'
import { Outlet } from 'react-router'
import CreateEditProfile from 'pages/profile/createEditProfile/createEditProfile'
import { Header, SideNav } from '../shared'
import useAuth from '../hooks/Auth'

const AuthLayout: React.FC = () => {
  const {
    isSubsId,
    loadingRole,
    isUserSynced,
    openEditProfile,
    setopenEditProfile,
    syncUserWithDatabase,
    errorCompanyDetails,
    user
  } = useAuth()
  useEffect(() => {
    if (user && !isUserSynced) {
      syncUserWithDatabase(user)
    }
  }, [user, isUserSynced, syncUserWithDatabase])

  useEffect(() => {
    if (!isSubsId && !loadingRole) {
      setopenEditProfile(true)
    }
  }, [isSubsId, loadingRole, setopenEditProfile])
  const handleClose = () => {
    setopenEditProfile(false)
  }
  return (
    <Container className="layout">
      <Header />
      <Container>
        {!errorCompanyDetails ? <SideNav /> : null}
        <Content className="content">
          <Outlet />
        </Content>
      </Container>
      {openEditProfile && (
        <CreateEditProfile
          open={openEditProfile}
          onClose={handleClose}
          isEditMode
        />
      )}
      <Footer />
    </Container>
  )
}

export default AuthLayout
